import axiosClient from './axiosClient';
import { ProjectTeamMemberModel } from '../Models/projectTeamMemberModel';

const projectTeamMemberService = {
  getAll: () => {
    return axiosClient.get('/ProjectTeamMember')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /ProjectTeamMember returned 404. Falling back to GET /project-team-members...");
          return axiosClient.get('/project-team-members');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(ProjectTeamMemberModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (teamMemberID) => {
    return axiosClient.get(`/ProjectTeamMember/${teamMemberID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /ProjectTeamMember/${teamMemberID} returned 404. Falling back to GET /project-team-members/${teamMemberID}...`);
          return axiosClient.get(`/project-team-members/${teamMemberID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectTeamMemberModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = ProjectTeamMemberModel.toBackend(payload);
    body.teamMemberId = 0;

    return axiosClient.post('/ProjectTeamMember', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /ProjectTeamMember returned 404. Falling back to POST /project-team-members...");
          return axiosClient.post('/project-team-members', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectTeamMemberModel.toFrontend(raw),
        };
      });
  },

  update: (teamMemberID, payload) => {
    const body = ProjectTeamMemberModel.toBackend({ ...payload, teamMemberID });

    return axiosClient.put('/ProjectTeamMember', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /ProjectTeamMember returned 404. Falling back to PUT /project-team-members...");
          return axiosClient.put('/project-team-members', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectTeamMemberModel.toFrontend(raw),
        };
      });
  },

  remove: (teamMemberID) => {
    return axiosClient.delete(`/ProjectTeamMember/${teamMemberID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /ProjectTeamMember/${teamMemberID} returned 404. Falling back to DELETE /project-team-members/${teamMemberID}...`);
          return axiosClient.delete(`/project-team-members/${teamMemberID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default projectTeamMemberService;
